import { useState, useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import LauncherContainer from '../launcher/container/LauncherContainer';
// @ts-expect-error not typed
import InitialMessageBubbleContainer from '../initial-message-bubble/containers/InitialMessageBubbleContainer';
import { withBrowserSizeContext } from '../containers/withBrowserSizeContext';
import WidgetWindow from './WidgetWindow';
import { FocusScope } from '@react-aria/focus';
import { AccessibilityContext } from 'conversations-visitor-message-history/accessibility/AccessibilityContext';
import QuickReplyGroupOutsideChatContainer from './QuickReplyGroupOutsideChatContainer';
import { getIsUngatedForCustomerAgentPrompts } from '../widget-data/selectors/widgetDataSelectors';
import { handleDragHandlePositionChange } from '../post-message/handleDragHandlePositionChange';
import { shouldShowAskMeAnythingLauncher } from '../utils/shouldShowAskMeAnythingLauncher';
import WidgetWelcomePage from './WidgetWelcomePage';
import InitialPageContentWrapper from './InitialPageContentWrapper';
import { CustomerAgentHoverProvider } from 'conversations-visitor-experience-components/contexts/CustomerAgentHoverContext';
import { getInitialMessageForWelcomePage } from '../selectors/widgetDataSelectors/getInitialMessageForWelcomePage';
import { getShouldHideWelcomeMessage } from '../selectors/getShouldHideWelcomeMessage';
import HiddenWelcomeMessage from 'conversations-visitor-experience-components/visitor-widget/components/HiddenWelcomeMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ApplicationLayout({
  inline,
  isOpen,
  mobile,
  onLauncherHover,
  showInitialMessageBubble,
  speechPocActive,
  toggleOpen,
  trackUserInteraction,
  widgetLocation,
  isAIChatBot
}) {
  const [animationsFinished, setAnimationsFinished] = useState(true);
  const [shouldRenderDialog, setShouldRenderDialog] = useState(isOpen);
  const [showAIPromptsOnRefresh, setShowAIPromptsOnRefresh] = useState(isAIChatBot);
  const [hasOpened, setHasOpened] = useState(false);
  const accessibilityContext = useContext(AccessibilityContext);
  const isUngatedForCustomerAgentPrompts = useSelector(getIsUngatedForCustomerAgentPrompts);
  useEffect(() => {
    const dragHandleState = shouldShowAskMeAnythingLauncher({
      isUngatedForCustomerAgentPrompts,
      hasOpenedWidget: hasOpened
    }) ? 'ask-me-anything-launcher' : 'icon-launcher';
    handleDragHandlePositionChange({
      dragHandleState
    });
  }, [isUngatedForCustomerAgentPrompts, hasOpened]);
  const openWidget = () => {
    setAnimationsFinished(false);
    trackUserInteraction();
    toggleOpen({
      isOpened: true,
      isUser: true
    });
    accessibilityContext.setShouldTrapFocus(true);
  };
  const closeWidget = () => {
    setAnimationsFinished(false);
    setHasOpened(true);
    trackUserInteraction();
    toggleOpen({
      isOpened: false,
      isUser: true
    });
  };
  const closeWidgetWelcomePage = () => {
    if (isAIChatBot) {
      setShowAIPromptsOnRefresh(false);
    }
    setAnimationsFinished(true);
    setHasOpened(true);
    trackUserInteraction();
  };
  const onOpenAnimationStarted = () => {
    setAnimationsFinished(false);
    setShouldRenderDialog(true);
    handleDragHandlePositionChange({
      dragHandleState: 'hidden'
    });
  };
  const onOpenAnimationFinished = () => {
    setAnimationsFinished(true);
    accessibilityContext.setShouldTrapFocus(true);
    handleDragHandlePositionChange({
      dragHandleState: 'widget-open'
    });
  };
  const onCloseAnimationStarted = () => {
    setAnimationsFinished(false);
    handleDragHandlePositionChange({
      dragHandleState: 'hidden'
    });
  };
  const onCloseAnimationFinished = () => {
    setAnimationsFinished(true);
    setShouldRenderDialog(false);
    accessibilityContext.setShouldTrapFocus(false);
    handleDragHandlePositionChange({
      dragHandleState: 'icon-launcher'
    });
  };
  const launcherHidden = isOpen && mobile || inline || isOpen && isUngatedForCustomerAgentPrompts;
  const showAskMeAnythingLauncher = shouldShowAskMeAnythingLauncher({
    isUngatedForCustomerAgentPrompts,
    hasOpenedWidget: hasOpened
  });
  const showContent = !isUngatedForCustomerAgentPrompts || isUngatedForCustomerAgentPrompts && animationsFinished;
  const initialMessage = useSelector(getInitialMessageForWelcomePage);
  const shouldHideWelcomeMessage = useSelector(getShouldHideWelcomeMessage);
  return /*#__PURE__*/_jsx(AccessibilityContext.Consumer, {
    children: ({
      shouldTrapFocus
    }) => /*#__PURE__*/_jsxs(FocusScope, {
      contain: shouldTrapFocus,
      autoFocus: false,
      children: [/*#__PURE__*/_jsx(WidgetWindow, {
        inline: inline,
        isOpen: isOpen || inline,
        shouldRenderDialog: shouldRenderDialog,
        mobile: mobile,
        widgetLocation: widgetLocation,
        onOpenAnimationStarted: onOpenAnimationStarted,
        onCloseAnimationFinished: onCloseAnimationFinished,
        onOpenAnimationFinished: onOpenAnimationFinished,
        onCloseAnimationStarted: onCloseAnimationStarted,
        onClose: closeWidget,
        speechPocActive: speechPocActive,
        showAskMeAnythingLauncher: showAskMeAnythingLauncher
      }), showContent && (mobile || !isUngatedForCustomerAgentPrompts) && /*#__PURE__*/_jsxs(_Fragment, {
        children: [showInitialMessageBubble && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(InitialMessageBubbleContainer, {
            onClick: openWidget,
            widgetLocation: widgetLocation
          }), /*#__PURE__*/_jsx(QuickReplyGroupOutsideChatContainer, {
            widgetLocation: widgetLocation
          })]
        }), !launcherHidden && /*#__PURE__*/_jsx("span", {
          "data-test-id": "chat-widget-launcher",
          onMouseOver: onLauncherHover,
          children: /*#__PURE__*/_jsx(LauncherContainer, {
            onClose: closeWidget,
            onOpen: openWidget,
            showAskMeAnythingLauncher: showAskMeAnythingLauncher,
            isUngatedForCustomerAgentPrompts: isUngatedForCustomerAgentPrompts
          })
        })]
      }), showContent && !mobile && isUngatedForCustomerAgentPrompts && !isOpen && /*#__PURE__*/_jsx(CustomerAgentHoverProvider, {
        enableHoverTracking: isAIChatBot,
        children: /*#__PURE__*/_jsxs(InitialPageContentWrapper, {
          widgetLocation: widgetLocation,
          showAskMeAnythingLauncher: showAskMeAnythingLauncher,
          shouldTrapFocus: isAIChatBot,
          children: [!showInitialMessageBubble && !shouldHideWelcomeMessage && /*#__PURE__*/_jsx(HiddenWelcomeMessage, {
            initialMessage: initialMessage
          }), (showInitialMessageBubble || showAIPromptsOnRefresh) && showAskMeAnythingLauncher && /*#__PURE__*/_jsx(WidgetWelcomePage, {
            onClose: closeWidgetWelcomePage,
            initialMessage: initialMessage
          }), !launcherHidden && /*#__PURE__*/_jsx(LauncherContainer, {
            onClose: closeWidget,
            onOpen: openWidget,
            showAskMeAnythingLauncher: showAskMeAnythingLauncher,
            isUngatedForCustomerAgentPrompts: true
          })]
        })
      })]
    })
  });
}
ApplicationLayout.displayName = 'ApplicationLayout';
export default withBrowserSizeContext(ApplicationLayout);